<template>
  <div>
    <div :class="classInput" class="justify-around">
      <div>
        <select
          class="input-form flex text-center"
          :id="idYear"
          v-model="yearValue"
          style="cursor: pointer !important"
        >
          <option value="AAAA" selected hidden>AAAA</option>
          <option
            :value="year"
            v-for="(year, i) in years"
            :key="i"
            :id="`${concatIdYear}_opt_${i}`"
          >
            {{ year }}
          </option>
        </select>
      </div>
      <div>
        <label
          for=""
          class="label-input text-center"
          style="font-size: 16px !important"
          >|</label
        >
      </div>
      <div>
        <select
          class="input-form text-center"
          :id="idMonth"
          v-model="monthValue"
          :disabled="yearValue == 'AAAA'"
          style="cursor: pointer !important"
        >
          <option :value="monthValue" selected hidden>{{ monthValue }}</option>
          <option
            :value="month"
            v-for="(month, i) in months"
            :key="i"
            :id="`${concatIdMonth}_opt_${i}`"
          >
            {{ month }}
          </option>
        </select>
      </div>
      <div>
        <label for="" class="label-input" style="font-size: 16px !important"
          >|</label
        >
      </div>
      <div>
        <select
          class="input-form flex text-center"
          :id="idDay"
          v-model="dayValue"
          v-on:change="changeDay()"
          :disabled="monthValue == 'MM'"
          style="cursor: pointer !important"
        >
          <option value="DD" selected hidden>DD</option>
          <option
            :value="day"
            v-for="(day, i) in days"
            :key="i"
            :id="`${concatIdDay}_opt_${i}`"
          >
            {{ day }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import enums from "../helpers/enums";
import {
  getDaysByYearAndMonth,
  getMonthsOfYearInLetters,
  getRangeOfYears,
  createDateStringByYearMonthDay,
} from "../helpers/dates";
import moment from "moment";

export default {
  name: "DateComponent",
  props: {
    description: {
      type: String,
      default: "",
    },
    day: {
      type: String,
      default: "DD",
    },
    month: {
      type: String,
      default: "MM",
    },
    year: {
      type: String,
      default: "AAAA",
    },
    disableControls: {
      type: Boolean,
      default: false,
    },
    classInput: {
      type: String,
      default: "flex shadow-md border-2 rounded-lg px-2 py-2 w-full ",
    },
    idYear: {
      type: String,
      default: "",
    },
    idMonth: {
      type: String,
      default: "",
    },
    idDay: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    const concatIdYear = ref("");
    const concatIdMonth = ref("");
    const concatIdDay = ref("");
    const years = ref([]);
    const months = ref([]);
    const days = ref([]);
    const dayValue = ref(props.day);
    const yearValue = ref(props.year);
    const monthValue = ref(props.month);

    const generateMonthsAndDays = (year, month, dropDownSelected) => {
      if (year != "AAAA" && dropDownSelected == "year") {
        months.value = getMonthsOfYearInLetters(year);
      }

      if (year != "AAAA" && month != "MM") {
        days.value = getDaysByYearAndMonth(year, enums.numericMonths[month]);
      }

      if (dayValue.value != "DD") {
        if (!days.value.includes(dayValue.value)) {
          dayValue.value = "DD";
          emitEvent("");
        } else {
          emitEvent(
            getCompleteDateSelected(
              yearValue.value,
              monthValue.value,
              dayValue.value
            )
          );
        }
      } else {
        emitEvent("");
      }

      if (monthValue.value != "MM") {
        if (!months.value.includes(monthValue.value)) {
          monthValue.value = "MM";
          dayValue.value = "DD";
        }
      }
    };

    const getYears = () => {
      years.value = getRangeOfYears(100);
    };

    const changeDay = () => {
      emitEvent(
        getCompleteDateSelected(
          yearValue.value,
          monthValue.value,
          dayValue.value
        )
      );
    };

    const emitEvent = (value) => {
      emit("get-complete-date-selected", value);
    };

    const getCompleteDateSelected = (year, month, day) => {
      return createDateStringByYearMonthDay(
        year,
        enums.numericMonths[month],
        day
      );
    };

    onMounted(() => {
      concatIdYear.value = props.idYear;
      concatIdMonth.value = props.idMonth;
      concatIdDay.value = props.idDay;
      getYears();

      if (
        yearValue.value != "" &&
        monthValue.value != "" &&
        moment(`${props.year}`).isValid()
      ) {
        months.value = getMonthsOfYearInLetters(yearValue);
        const totalDays = Array.from(
          Array(
            moment(`${props.year}-${props.month}`, "YYYY-MM").daysInMonth()
          ),
          (_, i) => (i + 1 < 10 ? `0${i + 1}` : `${i + 1}`)
        );
        days.value = totalDays;
      } else {
        yearValue.value = "AAAA";
        monthValue.value = "MM";
        dayValue.value = "DD";
      }
    });

    return {
      generateMonthsAndDays,
      getYears,
      changeDay,
      emitEvent,
      getCompleteDateSelected,
      concatIdYear,
      concatIdMonth,
      concatIdDay,
      years,
      months,
      days,
      dayValue,
      yearValue,
      monthValue,
    };
  },
  watch: {
    yearValue(val) {
      // console.log("🚀 ~ file: Date.vue ~ line 171 ~ yearValue ~ val", val);
      this.generateMonthsAndDays(val, this.monthValue, "year");
    },
    monthValue(val) {
      // console.log("🚀 ~ file: Date.vue ~ line 175 ~ monthValue ~ val", val);
      this.generateMonthsAndDays(this.yearValue, val, "month");
    },
  },
};
</script>

<style scoped>
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
  background-color: #fff;
}
select:focus {
  outline: none !important;
}
select[disabled] {
  color: #000;
}
.table {
  width: 0px !important;
  margin-bottom: 0px !important;
}
</style>
